export const ru = {
    all: 'За любой период',
    'audip-genres-title': 'Жанры',
    'day-description': {
        one: 'за {count} день',
        some: 'за {count} дня',
        many: 'за {count} дней',
        none: 'за {count} дней'
    },
    'description-by-day': {
        one: '{description} (за {count} день)',
        some: '{description} (за {count} дня)',
        many: '{description} (за {count} дней)',
        none: '{description} (за {count} дней)'
    },
    'interests-set': 'Набор интересов',
    long_term: 'Долгосрочные',
    short_term: 'Краткосрочные',
    'unavailable-goal': 'Цель не найдена'
};
